import { useEffect, useRef } from "react";
import { fillMarqueeTrack } from "@/utils/fillMarqueeTrack.js";

/**
 * HeroMarquee Component
 * Press logos infinite scrolling marquee
 */
export function HeroMarquee() {
  const trackRef = useRef(null);
  const assetsUrl = `${window.template_root}/src/public/`;

  const logos = [
    { name: "Forbes", src: `${assetsUrl}img/logos/forb.svg` },
    { name: "Fortune", src: `${assetsUrl}img/logos/fort.svg` },
    { name: "GQ", src: `${assetsUrl}img/logos/gq.svg` },
    { name: "Vogue", src: `${assetsUrl}img/logos/vog.svg` },
    { name: "Women's Health", src: `${assetsUrl}img/logos/wh.svg` },
    { name: "Sports Illustrated", src: `${assetsUrl}img/logos/si.svg` },
    { name: "New York Times", src: `${assetsUrl}img/logos/nyt.svg` },
    { name: "Wall Street Journal", src: `${assetsUrl}img/logos/wall.svg` },
    { name: "Men's Health", src: `${assetsUrl}img/logos/mc.svg` },
    { name: "Elle", src: `${assetsUrl}img/logos/ell.svg` },
    { name: "Cosmopolitan", src: `${assetsUrl}img/logos/cosm.svg` },
    { name: "Glamour", src: `${assetsUrl}img/logos/glam.svg` },
    { name: "Hello", src: `${assetsUrl}img/logos/hell.svg` },
    { name: "T Magazine", src: `${assetsUrl}img/logos/tall.svg` },
    { name: "Business Insider", src: `${assetsUrl}img/logos/bus.svg` },
  ];

  // Clone items for infinite loop effect
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    return fillMarqueeTrack(track);
  }, []);

  return (
    <section
      className="relative overflow-hidden py-4 pb-8 bg-accent-bg
                        max-md:py-2.5 max-md:pb-6"
      aria-label="Media logos"
    >
      <h3
        className="text-center text-[0.85rem] text-gray mb-6 font-medium
                     max-md:text-[0.75rem] max-md:mb-4"
      >
        Probiotic Benefits Are Covered In
      </h3>

      <div className="w-full overflow-hidden flex items-center">
        <div
          ref={trackRef}
          className="inline-flex items-center gap-16 flex-nowrap whitespace-nowrap animate-marquee
                     max-md:gap-8"
        >
          {logos.map((logo, index) => (
            <div
              key={index}
              className="w-[110px] h-[22px] bg-no-repeat bg-contain bg-center flex-shrink-0 opacity-60
                         max-md:w-[80px] max-md:h-[18px]"
              style={{ backgroundImage: `url('${logo.src}')` }}
              aria-label={logo.name}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default HeroMarquee;
